import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageLayout from "../../components/ui/PageLayout";
import { ApiConstants } from "../../constants/ApiConstants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import ChoresReport from "./ChoresReport";
import ContributionReport from "./ContributionReport";
import ExpensesReport from "./ExpensesReport";
import PaymentReport from "./PaymentReport";

const STATIC_PAYER_OPTIONS = [
  { value: "0", label: "Unpaid" },
  { value: "01", label: "Joint Account" },
];
const Reports = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || "chores");
  let profile: any = useContext(authContext);
  profile = profile?.data;
  const hhMembers = useMakeRequest();
  type OptionType = { value: string; label: string };
  const [memberOptions, setMemberOptions] = useState<OptionType[]>([]);

  useEffect(() => {
    hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers });
  }, []);

  useEffect(() => {
    if (hhMembers?.status) {
      const transformedData = hhMembers?.data?.data?.map((item: any) => ({
        value: item?.user?.uuid,
        label: profile?.uuid === item?.user?.uuid ? `Me` : item?.user?.name,
      }));
      setMemberOptions([...transformedData, ...STATIC_PAYER_OPTIONS]);
    }
  }, [hhMembers?.status]);

  useEffect(() => {
    return () => {
      $(".modal-backdrop").remove();
    };
  }, []);

  return (
    <PageLayout headerName='Reports' onlyTitle={false}>
      <div className="reports-page">
        {/* <TopHeader headerName="Reports" /> */}
        <div className="com-nav-pills">
          <ul
            className="nav nav-pills mb-3 page-padding-x pt-3"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "chores" ? "active" : ""}`}
                id="chores-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-profile"
                type="button"
                role="tab"
                aria-controls="pills-profile"
                aria-selected={activeTab === "chores"}
                onClick={() => setActiveTab("chores")}
              >
                Chores
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "expenses" ? "active" : ""}`}
                id="expense-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-home"
                type="button"
                role="tab"
                aria-controls="pills-home"
                aria-selected={activeTab === "expenses"}
                onClick={() => setActiveTab("expenses")}
              >
                Expenses
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "contributions" ? "active" : ""}`}
                id="contribution-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-contact"
                type="button"
                role="tab"
                aria-controls="pills-contact"
                aria-selected={activeTab === "contributions"}
                onClick={() => setActiveTab("contributions")}
              >
                Contributions
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "payments" ? "active" : ""}`}
                id="payment-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-payment"
                type="button"
                role="tab"
                aria-controls="pills-payment"
                aria-selected={activeTab === "payments"}
                onClick={() => setActiveTab("payments")}
              >
                Payments
              </button>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div
              className={`tab-pane fade ${activeTab === "chores" ? "show active" : ""}`}
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="chores-tab"
            >
              <ChoresReport doneByOptions={memberOptions} />
            </div>
            <div
              className={`tab-pane fade ${activeTab === "expenses" ? "show active" : ""}`}
              id="pills-home"
              role="tabpanel"
              aria-labelledby="expense-tab"
            >
              <ExpensesReport payers={memberOptions} />
            </div>
            <div
              className={`tab-pane fade ${activeTab === "contributions" ? "show active" : ""}`}
              id="pills-contact"
              role="tabpanel"
              aria-labelledby="contribution-tab"
            >
              <ContributionReport />
            </div>
            <div
              className={`tab-pane fade ${activeTab === "payments" ? "show active" : ""}`}
              id="pills-payment"
              role="tabpanel"
              aria-labelledby="payment-tab"
            >
              <PaymentReport fromReport={true} />
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Reports;
